import { defineComponent } from 'vue'
import type { PropType, ExtractPropTypes } from 'vue'

export const edittableColumnMultiselectProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  // 是否可编辑
  editable: Boolean,
  cellEditable: Boolean,
  // code
  code: [String, Array] as PropType<string | { value: string; content: string }[] | ((row: any) => { value: string; content: string }[])>,
  // input属性
  placeholder: String,
  collapseTags: Boolean,
  collapseTagsTooltip: Boolean,
})

export type EdittableColumnMultiselectProps = Partial<ExtractPropTypes<ReturnType<typeof edittableColumnMultiselectProps>>>

export default defineComponent({
  name: 'OEdittableColumnMultiselect',
  inheritAttrs: false,
  props: edittableColumnMultiselectProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
